export const communityPostSelector = state => state.communityPosts.get('communityPosts');
export const communityPostIsLoadingSelector = state => state.communityPosts.get('isLoading');
export const communityPostsHasMoreSelector = state => state.communityPosts.get('hasMorePosts');
export const communityPostsCountSelector = state => state.communityPosts.get('communityPosts').length;
